const DATA_API = 'data/data.json';
const PLACEHOLDER_POST_API = 'https://jsonplaceholder.typicode.com/posts/';
const NO_INTEREST_STORAGE_KEY = 'noInterest';
const RECENT_LIST_STORAGE_KEY = 'recentList';
const LAST_SAVE_DATE_STORAGE_KEY = 'lastSaveDate';

const Constants = {
  DATA_API,
  PLACEHOLDER_POST_API,
  NO_INTEREST_STORAGE_KEY,
  RECENT_LIST_STORAGE_KEY,
  LAST_SAVE_DATE_STORAGE_KEY,
};

export default Constants;
